/* eslint-disable consistent-return */
export const wohnlageScoreConvert = (score) => {
  if (score === 5.0) {
    return 5;
  }
  if (score >= 4.0 && score < 5.0) {
    return score % 1 >= 0.6 ? 4.5 : 4;
  }
  if (score >= 3.0 && score < 4.0) {
    return score % 1 >= 0.6 ? 3.5 : 3;
  }
  if (score >= 2.0 && score < 3.0) {
    return score % 1 >= 0.6 ? 2.5 : 2;
  }
  if (score >= 1.0 && score < 2.0) {
    return score % 1 >= 0.6 ? 1.5 : 1;
  }
  if (score >= 0.0 && score < 1.0) {
    return score % 1 >= 0.6 ? 0.5 : 0;
  }
  if (score >= 0.0 && score <= 0.04) {
    return 0;
  }
};

export const publicTransportScoreConvert = (score) => {
  if (score >= 0.96 && score <= 1) {
    return 5;
  }
  if (score >= 0.9 && score <= 0.95) {
    return score >= 0.9 + 0.95 ? 4.5 : 4;
  }
  if (score >= 0.75 && score <= 0.89) {
    return score >= 0.75 + 0.89 ? 3.5 : 3;
  }
  if (score >= 0.5 && score <= 0.74) {
    return score >= 0.5 + 0.74 ? 2.5 : 2;
  }
  if (score >= 0.05 && score <= 0.49) {
    return score >= 0.05 + 0.49 ? 1.5 : 1;
  }
  if (score >= 0.0 && score <= 0.04) {
    return 0;
  }
};

export const localSupplyScoreConvert = (score) => {
  if (score >= 0.9 && score <= 1) {
    return 5;
  }
  if (score >= 0.76 && score <= 0.89) {
    return score >= (0.76 + 0.89) / 2 ? 4.5 : 4;
  }
  if (score >= 0.56 && score <= 0.75) {
    return score >= (0.56 + 0.75) / 2 ? 3.5 : 3;
  }
  if (score >= 0.3 && score <= 0.55) {
    return score >= (0.3 + 0.55) / 2 ? 2.5 : 2;
  }
  if (score >= 0.05 && score <= 0.29) {
    return score >= (0.05 + 0.29) / 2 ? 1.5 : 1;
  }
  if (score >= 0.0 && score <= 0.04) {
    return 0;
  }
};

export const cultureScoreConvert = (score) => {
  if (score >= 0.98 && score <= 1) {
    return 5;
  }
  if (score >= 0.9 && score <= 0.97) {
    return score >= (0.9 + 0.97) / 2 ? 4.5 : 4;
  }
  if (score >= 0.76 && score <= 0.89) {
    return score >= (0.76 + 0.89) / 2 ? 3.5 : 3;
  }
  if (score >= 0.5 && score <= 0.75) {
    return score >= (0.5 + 0.75) / 2 ? 2.5 : 2;
  }
  if (score >= 0.05 && score <= 0.49) {
    return score >= (0.05 + 0.49) / 2 ? 1.5 : 1;
  }
  if (score >= 0.0 && score <= 0.04) {
    return 0;
  }
};
